import React, { FC, useEffect } from 'react';
import { useField } from 'formik';

import usePrefix from 'utils/usePrefix';
import { SchoolResponse } from 'utils/api/schools';
import FormikSelect, { FormikSelectOption } from 'components/FormikSelect';

interface Props {
  name: string;
  schools: SchoolResponse[];
  isDisabled?: boolean;
  margin?: string;
}

const SchoolSelect: FC<Props> = ({ name, schools, isDisabled = false, margin = '0' }) => {
  const t = usePrefix('ResqlExpert');
  const [field, , helpers] = useField<number | undefined>(name);

  const options: Array<FormikSelectOption<number>> = schools.map((s) => ({
    value: s.id,
    label: s.name,
  }));

  useEffect(() => {
    if (schools.length === 1 && field.value !== schools[0].id) {
      helpers.setValue(schools[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only re-run when the schools list changes; helpers/field.value would cause it to fight the user's manual selection
  }, [schools]);

  return (
    <FormikSelect<number>
      name={name}
      label={t('select_school')}
      placeholder={t('select_school_placeholder')}
      options={options}
      margin={margin}
      isDisabled={isDisabled || schools.length <= 1}
      isRequired={schools.length > 1}
    />
  );
};

export default SchoolSelect;
